import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { fetchPageAssets } from '../../ducks/hostedAssets.duck';

import { storableError } from '../../util/errors';
import { fetchSearchSellers } from '../../util/api';

export const ASSET_NAME = 'landing-page';
export const LANDING_SELLERS_PAGE_SIZE = 8;

const resultRefs = data => {
  return (data.data || []).map(({ id, type }) => ({ id, type }));
};

export const searchLandingSellers = createAsyncThunk(
  'LandingPage/searchLandingSellers',
  ({ searchParams, config, searchSellersFetcher }, { dispatch, rejectWithValue }) => {
    const fetcher = searchSellersFetcher || fetchSearchSellers;

    return fetcher(searchParams)
      .then(apiResponse => {
        const response = { data: apiResponse };
        const userFields = config?.user?.userFields;
        const sanitizeConfig = { userFields };

        dispatch(addMarketplaceEntities(response, sanitizeConfig));
        return response;
      })
      .catch(e => rejectWithValue(storableError(e)));
  }
);

const landingPageSlice = createSlice({
  name: 'LandingPage',
  initialState: {
    sellerSearchParams: null,
    sellerSearchInProgress: false,
    sellerSearchError: null,
    sellerResultRefs: [],
    sellerPagination: null,
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(searchLandingSellers.pending, (state, action) => {
        state.sellerSearchParams = action.meta.arg.searchParams;
        state.sellerSearchInProgress = true;
        state.sellerSearchError = null;
      })
      .addCase(searchLandingSellers.fulfilled, (state, action) => {
        state.sellerResultRefs = resultRefs(action.payload.data);
        state.sellerPagination = action.payload.data.meta;
        state.sellerSearchInProgress = false;
      })
      .addCase(searchLandingSellers.rejected, (state, action) => {
        state.sellerSearchInProgress = false;
        state.sellerSearchError = action.payload;
      });
  },
});

export default landingPageSlice.reducer;

export const loadData = (params, search, config, serverDataLoaders = {}) => dispatch => {
  const pageAsset = { landingPage: `content/pages/${ASSET_NAME}.json` };
  const pageAssetCall = dispatch(fetchPageAssets(pageAsset, true));
  const sellersCall = dispatch(
    searchLandingSellers({
      searchParams: {
        page: 1,
        perPage: LANDING_SELLERS_PAGE_SIZE,
      },
      config,
      searchSellersFetcher: serverDataLoaders.searchSellers,
    })
  );

  return Promise.all([pageAssetCall, sellersCall]);
};
